import React from "react";
import styles from "../styles/campaignNotifications.module.scss";

const PAGE_SIZE_OPTIONS = [10, 20, 50];

export default function CampaignListPagination({
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  canPrev,
  canNext,
  isFetching,
  onPrev,
  onNext,
  onPageSizeChange,
}) {
  if (!totalRecords && !isFetching) return null;

  const from =
    totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, totalRecords);

  return (
    <div className={styles.pagination}>
      <span className={styles.paginationMeta}>
        {totalRecords
          ? `Showing ${from}–${to} of ${totalRecords}`
          : "No campaigns"}
      </span>
      <div className={styles.paginationControls}>
        <select
          className={styles.filterSelect}
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
          aria-label="Rows per page"
          disabled={isFetching}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
        <button
          type="button"
          className={styles.secondaryBtn}
          onClick={onPrev}
          disabled={!canPrev || isFetching}
        >
          Previous
        </button>
        <span className={styles.paginationPage}>
          Page {currentPage} of {Math.max(totalPages, 1)}
        </span>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={onNext}
          disabled={!canNext || isFetching}
        >
          Next
        </button>
      </div>
    </div>
  );
}
